package com.patronat.top.ui.models

data class OwnerInfoData(
    val firstName: String = "",
    val lastName: String = "",
    val phone: String = "",
    val email: String = ""
)
